import { render, staticRenderFns } from "./HotelBasket.vue?vue&type=template&id=801c87a4&scoped=true"
import script from "./HotelBasket.vue?vue&type=script&lang=js"
export * from "./HotelBasket.vue?vue&type=script&lang=js"
import style0 from "./HotelBasket.vue?vue&type=style&index=0&id=801c87a4&prod&lang=scss&scoped=true"
import style1 from "./HotelBasket.vue?vue&type=style&index=1&id=801c87a4&prod&lang=scss&scoped=true"
import style2 from "./HotelBasket.vue?vue&type=style&index=2&id=801c87a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801c87a4",
  null
  
)

export default component.exports